module.exports = __webpack_public_path__ + "static/media/amazon_seller_central_01.e3a6b457.jpg";